export default __webpack_public_path__ + "static/media/s-5.620c70aa.png";